import React from "react";

export default function PageTitle({ Icon, title, subtitle }) {
  return (
    <div className="flex items-center mb-4 md:mb-0">
      <div className="bg-blue-100 p-2 rounded-lg mr-3">
        <Icon size={24} className="text-blue-600" />
      </div>
      <div>
        <h1 className="text-2xl font-bold">{title}</h1>
        <p className="text-gray-500 text-sm">{subtitle}</p>
      </div>
    </div>
  );
}
